import JSZip from 'jszip';
import { IColor, ICreateFaviconsArchiveParams } from '../interfaces';
import { applySVGProperties, parseSVG } from './svg-provider';
import { pngToIco, svgToPng } from './converters/file-type-converter';
import { IconBackgroundType } from '../enums/IconBackgroundType'; // https://github.com/Stuk/jszip

const files: ICreateFaviconsArchiveParams[] = [
    {
        // also used for .ico file!
        size: 16,
        fileName: 'favicon-16.png',
        type: 'png',
    },
    {
        // also used for .ico file!
        size: 32,
        fileName: 'favicon-32.png',
        type: 'png',
    },
    {
        // also used for .ico file!
        size: 48,
        fileName: 'favicon-48.png',
        type: 'png',
    },
    {
        size: 96,
        fileName: 'favicon-96.png',
        type: 'png',
    },
    {
        size: 128,
        fileName: 'favicon-128.png',
        type: 'png',
    },
    {
        size: 256,
        fileName: 'favicon-256.png',
        type: 'png',
    },
    {
        size: 250,
        fileName: 'favicon.svg',
        type: 'svg',
    },
    {
        size: 180,
        fileName: 'apple-touch-icon.png',
        type: 'png',
    },
    {
        size: 192,
        fileName: 'android-chrome-192.png',
        type: 'png',
    },
    {
        size: 512,
        fileName: 'android-chrome-512.png',
        type: 'png',
    },
    {
        size: 150,
        fileName: 'mstile-150.png',
        type: 'png',
    },
];

export const createFaviconsArchive = async (
    iconSvg: string,
    strokeWidth: number,
    strokeColor: IColor,
    hasStroke: boolean,

    fillColor: IColor,
    hasFill: boolean,

    backgroundType: IconBackgroundType,
    backgroundColor: IColor,

    rotation: number,
    scale: number,

    sharpness: number,
    smoothness: number
) => {

    const map = new Map();

    const zip = new JSZip();
    const img = zip.folder('favicons');
    if(!img) return null;

    for(let fileItem of files){
        let $svg = map.get(fileItem.size);

        if(!$svg){
            $svg = parseSVG(iconSvg);
            applySVGProperties(
                $svg,
                fileItem.size,

                strokeWidth,
                strokeColor,
                hasStroke,

                fillColor,
                hasFill,

                backgroundType,
                backgroundColor,

                rotation,
                scale,

                sharpness,
                smoothness
            );
            map.set(fileItem.size, $svg);
        }

        if(!$svg) continue;

        switch (fileItem.type){

            case 'svg': {
                const data = (new XMLSerializer()).serializeToString($svg);
                const svgBlob = new Blob([data], {type: 'image/svg+xml;charset=utf-8'});
                img.file(fileItem.fileName, svgBlob);
                break;
            }

            // png
            default: {
                const svgToPngResult = await svgToPng($svg);
                if(!svgToPngResult || !svgToPngResult.blob) continue;

                img.file(fileItem.fileName, svgToPngResult.blob);
                break;
            }
        }
    }

    // create 'favicon.ico'
    const pngToIcoResult = await pngToIco(map.get(16), map.get(32), map.get(48));
    if(pngToIcoResult){
        img.file('favicon.ico', pngToIcoResult.blob);
    }

    img.file('manifest.json', getSiteWebManifest());
    img.file('browserconfig.xml', getBrowseConfig());

    return await zip.generateAsync({ type: 'blob' });
};

export const getBrowseConfig = () => {
  return `<?xml version="1.0" encoding="utf-8"?>
<browserconfig>
    <msapplication>
        <tile>
            <square150x150logo src="/mstile-150.png"/>
            <TileColor>#da532c</TileColor>
        </tile>
    </msapplication>
</browserconfig>`;
};

export const getSiteWebManifest = () => {
  return `{
    "name": "",
    "short_name": "",
    "icons": [
        {
            "src": "/android-chrome-192.png",
            "sizes": "192x192",
            "type": "image/png"
        },
        {
            "src": "/android-chrome-512.png",
            "sizes": "512x512",
            "type": "image/png"
        }
    ],
    "theme_color": "#ffffff",
    "background_color": "#ffffff",
    "display": "standalone"
}`;
};
